/* Theme-owned media lifecycle. Uses only media already uploaded to this store. */
(()=>{
  function inView(v){const r=v.getBoundingClientRect();return r.width>0&&r.height>0&&r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth}
  function start(v){v.muted=true;v.defaultMuted=true;v.loop=true;v.playsInline=true;let changed=false;v.querySelectorAll('source[data-src]').forEach(s=>{if(!s.getAttribute('src')){s.src=s.dataset.src;changed=true}});if(changed)v.load();if(!document.hidden&&inView(v)){const p=v.play();if(p)p.catch(()=>{})}}
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)start(e.target)}),{threshold:0.05});
  function bind(root){root.querySelectorAll('video').forEach(v=>{if(v.dataset.themeMediaBound)return;v.dataset.themeMediaBound='true';observer.observe(v);v.addEventListener('loadeddata',()=>start(v));v.addEventListener('canplay',()=>start(v));if(inView(v))start(v)})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>bind(document));else bind(document);
  document.addEventListener('shopify:section:load',e=>bind(e.target));
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)document.querySelectorAll('video').forEach(start)});
  addEventListener('pageshow',()=>document.querySelectorAll('video').forEach(start));
})();

/* Keep the captured review cards in the source order while matching the
   source widget's responsive column count. The snapshot is flattened once;
   later resizes only redistribute that stable card list. */
(()=>{
  const states=new WeakMap();
  const columnCount=()=>document.documentElement.clientWidth<768?2:document.documentElement.clientWidth<1024?3:4;
  function reflow(){document.querySelectorAll('.wise-product-reviews').forEach(review=>{
    const first=review.querySelector('.wr-id-review-column');if(!first)return;
    const container=first.parentElement;let state=states.get(container);
    if(!state){
      const source=[...container.children].filter(node=>node.classList.contains('wr-id-review-column'));
      const cards=[];
      for(let row=0;row<Math.max(...source.map(column=>column.children.length));row++)source.forEach(column=>{if(column.children[row])cards.push(column.children[row])});
      state={cards,count:0};states.set(container,state);
    }
    const count=columnCount();if(state.count===count)return;state.count=count;
    const columns=Array.from({length:count},(_,index)=>{const column=document.createElement('div');column.className=`wr-id-review-column wr-id-review-column-${index}`;column.style.flexBasis=`${100/count}%`;column.style.maxWidth=`${100/count}%`;return column});
    state.cards.forEach((card,index)=>columns[index%count].append(card));
    container.replaceChildren(...columns);
  })}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reflow);else reflow();
  addEventListener('resize',reflow);document.addEventListener('shopify:section:load',reflow);
})();

